// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"279":"2f4d24d1","453":"9017b210","661":"7edad145","767":"05db42dc","845":"e9b63e48"}[chunkId] + ".js";
};